import { LightTooltip } from '@sales-center/components'
import InfoOutlined from '@mui/icons-material/InfoOutlined'
import * as React from 'react'
import { getStyles } from './styling'
import { useTheme } from '@mui/material/styles'

export const UseSystemNameLabel = () => {
  const styles = getStyles(useTheme())
  return (
    <>
      <span style={styles.useSystemNameContainer}>Use System Name</span>{' '}
      <LightTooltip
        sx={{
          ...styles.tooltipHotspot,
        }}
        title="System Name uses service codes added to Opportunity"
      >
        <InfoOutlined
          sx={styles.icon}
          data-test-id="opportunityUseSystemNameInfoIcon"
        />
      </LightTooltip>
    </>
  )
}
UseSystemNameLabel.displayName = 'UseSystemNameLabel'
